import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { llmCheck, getTypePrefix } from '@/api'

/**
 * 获取LLM审核列表
 */
export const queryKnowledgeReviewPageAction = createAsyncThunk(
    getTypePrefix(llmCheck.queryKnowledgeReviewPageUrl),
    async (data) => await okHttp(llmCheck.queryKnowledgeReviewPageUrl, {    
        method: 'POST',
        data
    })
)

/**
 * 导出LLM审核列表
 */
export const downloadKnowledgeReviewAction = createAsyncThunk(
    getTypePrefix(llmCheck.downloadKnowledgeReviewUrl),
    async (data) => await okHttp(llmCheck.downloadKnowledgeReviewUrl, { 
        method: 'POST',
        data
    })
)

/**
 * 批量删除LLM审核
 */
export const batchRemoveKnowledgeReviewAction = createAsyncThunk(
    getTypePrefix(llmCheck.batchRemoveKnowledgeReviewUrl),
    async (data) => await okHttp(llmCheck.batchRemoveKnowledgeReviewUrl, {
        method: 'POST',
        data
    })
)

/**
 * 修改LLM审核
 */
export const modifyKnowledgeReviewStatusAction = createAsyncThunk(
    getTypePrefix(llmCheck.modifyKnowledgeReviewStatusUrl),
    async (data) => await okHttp(llmCheck.modifyKnowledgeReviewStatusUrl, {
        method: 'POST',
        data
    })
)

/**
 * 获取场景列表
 */
export const querySceneListAction = createAsyncThunk(
    getTypePrefix(llmCheck.querySceneListUrl),
    async (data) => await okHttp(llmCheck.querySceneListUrl, {
        method: 'POST',
        data
    })
)
